import React from 'react';
import { Icon } from '@/shared/icons'
/**
 * Props do FilterChip
 */
export interface FilterChipProps {
  /** Nome do filtro (ex: "Prioridade") */
  label: string;
  /** Valor formatado (ex: "Alta, Média") */
  value: string;
  /** Callback ao clicar no X para remover */
  onRemove: () => void;
  /** Callback ao clicar no chip para editar */
  onClick: () => void;
}

/**
 * Chip compacto que exibe um filtro ativo.
 * Clicável para editar, com botão X para remover.
 *
 * @example
 * ```tsx
 * <FilterChip
 *   label="Prioridade"
 *   value="Alta, Média"
 *   onClick={() => handleEdit('priority')}
 *   onRemove={() => handleRemove('priority')}
 * />
 * ```
 */
export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  value,
  onRemove,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 pl-2.5 pr-1.5 py-1.5 rounded-lg text-xs transition-all duration-150 cursor-pointer"
      style={{
        backgroundColor: 'var(--theme-button-ghost-hover)',
        color: 'var(--theme-header-text)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--theme-header-button-hover)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--theme-button-ghost-hover)';
      }}
    >
      <span className="font-medium" style={{ color: 'var(--theme-muted-text)' }}>
        {label}:
      </span>
      <span className="font-semibold ml-0.5">{value}</span>
      <span
        role="button"
        tabIndex={-1}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="ml-1 p-0.5 rounded transition-colors"
        style={{ color: 'var(--theme-muted-text)' }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--theme-header-text)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--theme-muted-text)';
        }}
      >
        <Icon name="x" className="w-3 h-3" />
      </span>
    </button>
  );
};

FilterChip.displayName = 'FilterChip';
